export const updateDisplayNameToLabel = arr =>
    arr.map(({ displayName, ...rest }) =>
        displayName ? { ...rest, label: displayName } : rest
    );
